<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Meus Pontos
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="pontos-page__content">
            <horario-tabs v-model="tab" class="pontos-page__tabs" />

            <section v-if="tab === 0" class="pontos-page__section">
              <horario-dia-filtro
                v-model="dataSelecionada"
                class="pontos-page__filter"
                @buscar="buscarDia"
              />
              <horario-lista-agrupada :registros="registrosDia" />
            </section>

            <section v-if="tab === 1" class="pontos-page__section">
              <v-btn color="primary" class="pontos-page__action" @click="buscarUltimos10Dias">
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada :registros="registrosUltimos10Dias" />
            </section>

            <section v-if="tab === 2" class="pontos-page__section">
              <horario-periodo-filtro
                class="pontos-page__filter"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada
                :registros="registrosPeriodo"
                :consulta-iniciada="consultaPeriodoIniciada"
              />
            </section>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto — Colaborador"
      @close="fecharPdf"
    />

    <atraso-justificado-obligatorio-modal />
  </main-template>
</template>

<script>
import EModalEspelhoPontoPdf from "@/components/Instrutores/EModalEspelhoPontoPdf.vue";
import HorarioDiaFiltro from "@/components/Instrutores/HorarioDiaFiltro.vue";
import HorarioListaAgrupada from "@/components/Instrutores/HorarioListaAgrupada.vue";
import HorarioPeriodoFiltro from "@/components/Instrutores/HorarioPeriodoFiltro.vue";
import HorarioTabs from "@/components/Instrutores/HorarioTabs.vue";
import AtrasoJustificadoObligatorioModal from "@/components/Colaboradores/AtrasoJustificadoObligatorioModal.vue";

export default {
  name: "MeusPontosPage",
  components: {
    EModalEspelhoPontoPdf,
    HorarioDiaFiltro,
    HorarioListaAgrupada,
    HorarioPeriodoFiltro,
    HorarioTabs,
    AtrasoJustificadoObligatorioModal,
  },
  data() {
    return {
      tab: 0,
      dataSelecionada: new Date().toISOString().slice(0, 10),
      registrosDia: null,
      registrosUltimos10Dias: null,
      registrosPeriodo: null,
      consultaPeriodoIniciada: false,
      dialogPdf: false,
      pdf: null,
    };
  },
  mounted() {
    this.buscarDia();
    this.buscarUltimos10Dias();
  },
  methods: {
    async buscarDia() {
      try {
        this.$loaderService.open("Carregando pontos");
        this.registrosDia = await this.$services.colaboradorPontosService.meusPontosDia({
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      try {
        this.registrosUltimos10Dias =
          await this.$services.colaboradorPontosService.meusPontosUltimos10Dias();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarPeriodo(form) {
      if (!form?.data_inicio || !form?.data_fim) return;

      try {
        this.consultaPeriodoIniciada = true;
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.colaboradorPontosService.meusPontosPeriodo(
          form
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      if (!form?.data_inicio || !form?.data_fim) return;

      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.colaboradorPontosService.meusPontosPeriodoPdf(form);
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
  },
};
</script>

<style scoped>
.pontos-page__content {
  padding: 24px;
}
.pontos-page__tabs {
  margin-top: 4px;
}
.pontos-page__section {
  margin-top: 20px;
}
.pontos-page__filter,
.pontos-page__action {
  margin-bottom: 20px;
}
</style>
